import "./text_area.scss";

const TextArea = (props) => {
  return (
    <div className={`form-group ${props.label ? "m-1" : ""}`}>
      {props.label && (
        <label htmlFor={props.id}>
          {props.label}{" "}
          {props.required && <span style={{ color: "red" }}>(*)</span>}
        </label>
      )}
      <textarea
        style={props.style}
        required={props.required}
        readOnly={props.isReadOnly}
        className={`form-control ${props.className}`}
        id={props.id}
        name={props.id}
        value={props.value}
        placeholder={props.placeholder}
        onChange={props.onChange}
        rows={props.rows ?? 4}
      />
    </div>
  );
};

export default TextArea;
